<template>
  <div>
    <v-snackbar
      top
      outlined
      v-model="showSnack"
      color="success"
      timeout="3000"
      centered
    >
      {{ snackMessage }}
    </v-snackbar>

    <!-- Full Customers View -->
    <div v-if="showFullCustomersView">
      <v-container fluid class="pa-2">
        <v-row class="ma-2">
          <v-col cols="10">
            <h1>All Customers</h1>
          </v-col>
          <v-col cols="2" class="text-right">
            <v-btn
              color="primary"
              @click="showFullCustomersView = false"
              outlined
            >
              Back to Lookup
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <customers-view/>
    </div>

    <v-container fluid v-if="!showFullCustomersView">
      <div class="ma-2">
        <v-row>
          <v-col cols="10">
            <h1>Customer Lookup</h1>
            <p class="subtitle-1 grey--text">Search for customers by email or name</p>
          </v-col>
          <v-col cols="2" class="text-right">
            <v-btn
              color="primary"
              @click="showFullCustomersView = true"
              outlined
            >
              Show All Customers
            </v-btn>
          </v-col>
        </v-row>

        <v-toolbar flat>
          <v-spacer/>
          <customer-autocomplete
            style="width: 300px"
            v-model="selectedCustomer"
            @input="onCustomerSelected"
          />
          <v-spacer/>
        </v-toolbar>
      </div>
    </v-container>

  </div>
</template>

<script>
import urlState from "@/router/urlState";
import CustomersView from './Customers.vue';
import CustomerAutocomplete from '@/components/CustomerAutocomplete.vue';

export default {
  mixins: [urlState],
  name: 'CustomersLookup',
  components: {
    CustomersView,
    CustomerAutocomplete
  },
  data() {
    return {
      showSnack: false,
      snackMessage: '',
      showFullCustomersView: false,
      selectedCustomer: null
    }
  },
  methods: {
    onCustomerSelected(customer) {
      if (customer) {
        this.$router.push({name: 'Customer', params: {id: customer.uid}});
      }
    },
  },

  mounted() {
    // ?all=true opens the full customers table instead of the lookup
    this.syncToUrl({
      param: 'showFullCustomersView', urlParam: 'all', initFromRoute: true,
      transformCallback: (v) => v ? 'true' : '',
      parseCallback: (v) => v === 'true'
    });

    // Focus on the search field when the page loads
    this.$nextTick(() => {
      const searchField = this.$el.querySelector('input[type="text"]');
      if (searchField) {
        searchField.focus();
      }
    });
  },
}
</script>

<style scoped>
.v-data-table >>> tbody tr:hover {
  background-color: #f5f5f5 !important;
}
</style>